import { Spinner, SpinnerProps } from "react-bootstrap";
import { ColorAA } from "./constants";
import styled from "styled-components";

const StyledSpinner = styled(Spinner)<SpinnerProps>`
  ${({ variant }) =>
    variant === "light" && `color: ${ColorAA.yellow} !important;`}
  position: relative;
  top: calc(100% / 2 - 1rem);
  left: calc(100% / 2 - 1rem);
`;

const AASpinner = (props: SpinnerProps) => {
  return <StyledSpinner {...props} />;
};

export default AASpinner;
